if (!customElements.get('delivery-information')) {
  class DeliveryInformation extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        toggleHandler: '.js-toggle-delivery-information',
        content: '.popup__content',

        contentActiveClass: 'popup--active',
      };

      this.toggleHandlers = this.querySelectorAll(this.selectors.toggleHandler);

      this.toggleHandlers.forEach((handler) => {
        handler.addEventListener('click', this.toggleInformation.bind(this));
      });
    }

    toggleInformation(e) {
      e.preventDefault();

      const content = this.querySelector(this.selectors.content);

      if (content.classList.contains(this.selectors.contentActiveClass)) {
        content.classList.remove(this.selectors.contentActiveClass);
      } else {
        content.classList.add(this.selectors.contentActiveClass);
      }

      window.handlers['toggleOverlay']();
    }
  }

  customElements.define('delivery-information', DeliveryInformation);
}
